import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["onSubmit", "id"]
const _hoisted_2 = { class: "umbraco-form__button-container" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 1,
  class: "umbraco-form__success"
}
const _hoisted_5 = { class: "umbraco-form__success__message" }

import { PropType, provide, ref } from "vue";
import { IUmbracoForm } from "@/models/umbraco-forms/IUmbracoForm";
import { UmbracoFormsApi, UrlApi } from "@/services/Api";
import { FormState } from "@/models/umbraco-forms/FormState";
import { IAntiForgeryToken } from "@/models/umbraco-forms/IAntiForgeryToken";
import { IUmbracoFormUserPreValues } from "@/models/umbraco-forms/IUmbracoFormUserPreValues";


export default /*#__PURE__*/_defineComponent({
  __name: 'UmbracoForm',
  props: {
  definition: {
    type: Object as PropType<IUmbracoForm>,
    required: true,
  },
  preValues: {
    type: Object as PropType<IUmbracoFormUserPreValues>,
    required: false,
  },
  antiForgeryToken: {
    type: Object as PropType<IAntiForgeryToken>,
    required: true,
  },
},
  setup(__props) {

const props = __props;


const state = ref<FormState>(FormState.Loading);
const onSubmit = async (ev) => {
  try {
    state.value = FormState.Submitting;
    const formData = new FormData(ev.target);
    const formProps = Object.fromEntries(formData);
    await UmbracoFormsApi.post(props.definition?.id, formProps, props.antiForgeryToken);
    state.value = FormState.Complete;
    if (props.definition?.gotoPageOnSubmit) {
      const url = await UrlApi.get(props.definition?.gotoPageOnSubmit);
      window.location.href = url;
    }
  } catch (e) {
    console.log(e);
  } finally {
    if (state.value != FormState.Complete) {
      state.value = FormState.Normal;
    }
  }
};
provide("prevalues", props.preValues);

return (_ctx: any,_cache: any) => {
  const _component_icon_checkmark_green = _resolveComponent("icon-checkmark-green")!

  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(onSubmit, ["prevent"]),
    id: __props.definition.id,
    class: "umbraco-form umbraco-forms-form"
  }, [
    (state.value != _unref(FormState).Complete)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _renderSlot(_ctx.$slots, "default", { definition: __props.definition }),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("button", {
              type: "submit",
              class: "umbraco-form__submit-button btn btn-primary button button--default",
              disabled: state.value == _unref(FormState).Submitting
            }, _toDisplayString(__props.definition.submitLabel), 9, _hoisted_3)
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createVNode(_component_icon_checkmark_green),
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.definition.messageOnSubmit), 1)
        ]))
  ], 40, _hoisted_1))
}
}

})